
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/celebrity",
      function () {
        return require("private-next-pages/celebrity/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/celebrity"])
      });
    }
  